const loadPackages = async () => {
  let packages = window.sessionStorage.getItem("packages");
  const sessionLocale = window.sessionStorage.getItem("package-locale");
  const sessionCurrency = window.sessionStorage.getItem("package-currency");
  const onecomConfig = window.onecomConfig;

  if (
    sessionLocale !== onecomConfig.locale ||
    sessionCurrency !== onecomConfig.currency
  ) {
    packages = false;
  }

  if (!packages) {
    await window
      .fetch("/ajax-new-size-price.do", {
        method: "GET",
        cache: "no-cache",
        mode: "cors",
      })
      .then((response) => response.json())
      .then((response) => {
        window.sessionStorage.setItem(
          "packages",
          JSON.stringify(response.sizes),
        );
        window.sessionStorage.setItem("package-locale", onecomConfig.locale);
        window.sessionStorage.setItem(
          "package-currency",
          onecomConfig.currency,
        );
        packages = response.sizes;
        return true;
      });
  }
  return typeof packages === "string" ? JSON.parse(packages) : packages;
};

export default loadPackages;
